export const CONFIRM_POPUP_MESSAGE =
  'Your upload is not finished yet. Do you want cancel the upload?'

export const SUCCESS_STATUS_REQUEST = 200



// WEBPACK FOOTER //
// ./src/Containers/Header/Modals/AddConversionModal/constants.js